module.exports = __webpack_public_path__ + "static/3-bd84ab1c70573655d77b5e0c435a434d.jpg";